import gql from 'graphql-tag';

export const getValvePositions = gql`
  query getValvePositions($aorId: String) {
    getValvePositions(aorId: $aorId) {
      id
      name
    }
  }
`;
